import type { Schema } from '@wix/wix-data-schema-types'

export const isCollectionRemoved = (
  collections: Schema[],
  collectionName: string,
): boolean => {
  const collection = collections.find(({ id }) => id === collectionName)
  return !collection || Boolean(collection.isDeleted)
}

export const isCollectionRemovedButCanBeRestored = (
  collections: Schema[],
  collectionName: string,
): boolean => {
  const collection = collections.find(({ id }) => id === collectionName)
  return Boolean(collection?.isDeleted)
}
